import { useNavigate } from "react-router-dom";
import { Plus, Coins } from "lucide-react";
import { fmtCoin, coinToRp } from "@/lib/format";
import { Verified } from "@/components/common";

export default function CoinCard({ user, children, worker = false }) {
  const nav = useNavigate();
  const bg = worker ? "from-amber-500 via-orange-600 to-slate-900" : "from-emerald-600 via-teal-700 to-slate-900";
  return (
    <div data-testid="coin-balance-card" className={`relative overflow-hidden grain rounded-3xl p-5 text-white shadow-lg bg-gradient-to-br ${bg} fade-up`}>
      <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10" />
      <div className="relative">
        <p className="text-xs uppercase tracking-[0.2em] text-white/70">{worker ? "Mode Worker" : "Halo,"}</p>
        <div className="flex items-center gap-1.5 mt-0.5">
          <h2 data-testid="home-user-name" className="font-display text-xl font-extrabold truncate">{user.name}</h2>
          <Verified show={user.kyc_status === "approved"} />
        </div>
        <div className="mt-4 flex items-end justify-between">
          <div>
            <p className="text-xs text-white/70 flex items-center gap-1"><Coins className="w-3.5 h-3.5" /> Saldo Koin</p>
            <p data-testid="coin-balance-value" className="font-mono text-3xl font-bold leading-tight">{fmtCoin(user.coins)}</p>
            <p className="text-xs text-white/70">{coinToRp(user.coins)}</p>
          </div>
          <button data-testid="topup-modal-trigger" onClick={() => nav("/coins?topup=1")}
            className="flex items-center gap-1 bg-white text-slate-900 font-bold text-sm px-4 py-2 rounded-full hover:scale-105 active:scale-95 transition-transform">
            <Plus className="w-4 h-4" /> Top Up
          </button>
        </div>
        {children && <div className="mt-4 pt-4 border-t border-white/15">{children}</div>}
      </div>
    </div>
  );
}
